const SALE_DRAFT_PREFIX = "sale_draft:";

export function createSaleDraftKey() {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }
  return `${Date.now()}-${Math.random().toString(16).slice(2)}`;
}

export function saveSaleDraft(key, data) {
  if (!key || typeof sessionStorage === "undefined") return;
  try {
    sessionStorage.setItem(`${SALE_DRAFT_PREFIX}${key}`, JSON.stringify(data));
  } catch (e) {
    console.warn("saveSaleDraft failed", e);
  }
}

export function loadSaleDraft(key) {
  if (!key || typeof sessionStorage === "undefined") return null;
  try {
    const raw = sessionStorage.getItem(`${SALE_DRAFT_PREFIX}${key}`);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function clearSaleDraft(key) {
  if (!key || typeof sessionStorage === "undefined") return;
  try {
    sessionStorage.removeItem(`${SALE_DRAFT_PREFIX}${key}`);
  } catch {
    // ignore
  }
}
